import { z } from "zod";

export const ContasPagarSchema = z.object({
    idContasPagar: z.number().nullable(),
    nrContasPagar: z.string().nullable().optional(),
    idTipoConta: z.number().nullable().optional(),
    idBancoPagamento: z.number().nullable().optional(),
    idCentroCusto: z.number().nullable().optional(),
    idPgtoColeta: z.number().nullable().optional(),
    idOrdemCompra: z.number().nullable().optional(),
    listaIdOrdemCompra: z.array(z.number()).nullable().optional(),
    idItemFolhaPagamento: z.number().nullable().optional(),
    idSubconta: z.number().nullable().optional(),
    idFornecedor: z.number().nullable().optional(),
    idFuncionario: z.number().nullable().optional(),
    idFuncionarioPago: z.number().nullable().optional(),
    idBanco: z.number().nullable().optional(),
    idProdutoServico: z.number().nullable().optional(),
    idPgtoMedicao: z.number().nullable().optional(),
    idMedicaoTerceirizacao: z.number().nullable().optional(),

    valorPagar: z.coerce.number().positive({ message: "Valor a Pagar deve ser positivo." }),
    dataPagar: z.coerce.date({ invalid_type_error: "Data a Pagar inválida." }).nullable().default(null),
    dataPago: z.coerce.date({ invalid_type_error: "Data a Pago inválida." }).nullable().default(null),
    valorPago: z.coerce.number().nullable().optional(),
    valorMax: z.coerce.number().nullable().optional(),
    outros: z.string().nullable().optional(),
    status: z.number().nullable().optional(),
    observacao: z.string().nullable().optional(),
    formaPagamento: z.string().nullable().optional(),
    nrDocumentos: z.string().nullable().optional(),
    nrNotaFiscal: z.string().nullable().optional(),
    informacoesGerais: z.string().nullable().optional(),
    nrNotaFiscalEspecial: z.string().nullable().optional(),
    nome: z.string().nullable().optional(),
    rateio: z.boolean().nullable().optional(),
    valorRateio: z.number().nullable().optional(),
    dataCriacao: z.coerce.date({ invalid_type_error: "Data a Criação inválida." }).nullable().default(null),
    dataCompetencia: z.coerce.date({ invalid_type_error: "Data a Competência inválida." }).nullable().default(null),
    valorJuros: z.coerce.number().nullable().optional(),
    valorMulta: z.coerce.number().nullable().optional(),


    arquivo1: z.instanceof(File).nullable().default(null),
    nomeArquivo1: z.string().nullable().optional(),
    arquivo2: z.instanceof(File).nullable().default(null),
    nomeArquivo2: z.string().nullable().optional(),
    arquivo3: z.instanceof(File).nullable().default(null),
    nomeArquivo3: z.string().nullable().optional(),

    limparArquivo1: z.boolean().optional().default(false),
    limparArquivo2: z.boolean().optional().default(false),
    limparArquivo3: z.boolean().optional().default(false),

    isFornecedor: z.boolean().optional().default(true),


});

export type ContasPagarForm = z.infer<typeof ContasPagarSchema>;

export const defaultContaPagarForm: Partial<ContasPagarForm> = {
    idContasPagar: 0,
    status: 0,
    isFornecedor: true,
    listaIdOrdemCompra: [],

};

